/**
 * 异步锁
 */
import { Mutex } from 'async-mutex';

const mutex = new Mutex();

export default mutex;
